import HCheckArray from "@rf-helper/check-have-value";
import { IFileData } from "./create-file-data";

export const HCreteFileDataToServer = (item: IFileData) => {
  if (item) {
    return item.id;
    //   return item.file;
    // } else if (item.url?.includes("https")) {
    //   return item.url.includes("https")
    //     ? (item.url.split("/").pop() as string)
    //     : item.url;
    // } else {
    // return null;
  } else {
    return null;
  }
};
